import make, { Enum } from '@xaamin/enum';

class AutofacturacionFileStatus extends Enum {
  name = 'AutofacturacionFileStatus';

  enum = {
    pending: 0,
    error: -2,
    completed: 1,
    uploading: 2,
    uploaded: 3,
    processing: 4,
    queued: 5,
    processed: 6,
    stamping: 7,
    undefined: 999,
  };
}

export default make(AutofacturacionFileStatus);
